import axios from "axios";
import jwt_decode from "jwt-decode";
import socket from "../socket";

export const displayAlert = () => {
  return {
    type: "DISPLAY_ALERT",
  };
};

export const clearAlert = () => {
  setTimeout(() => {
    return {
      type: "CLEAR_ALERT",
    };
  }, 1000);
};

export const registerUser = (currentUser) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "REGISTER_USER_BEGIN" });
      const { data } = await axios.post(
        `${process.env.REACT_APP_USERS_API_URL}/auth/register`,
        currentUser
      );
      const { token } = data;
      let user = jwt_decode(token);
      console.log(user);
      dispatch({ type: "REGISTER_USER_SUCCESS", payload: { user } });
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      socket.auth = {
        username: JSON.parse(localStorage.getItem("user")).username,
      };
      socket.connect();
    } catch (error) {
      console.log(error.response);
      dispatch({
        type: "REGISTER_USER_ERROR",
        payload: { msg: error.response.data.msg },
      });
    }
    setTimeout(() => {
      dispatch({
        type: "CLEAR_ALERT",
      });
    }, 2000);
  };
};

export const loginUser = (currentUser) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LOGIN_USER_BEGIN" });
      const { data } = await axios.post(
        `${process.env.REACT_APP_USERS_API_URL}/auth/login`,
        currentUser
      );
      console.log(data);
      const { token } = data;
      let user = jwt_decode(token);
      console.log(user);
      dispatch({ type: "LOGIN_USER_SUCCESS", payload: { user } });
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      socket.auth = {
        username: JSON.parse(localStorage.getItem("user")).username,
      };
      socket.connect();
    } catch (error) {
      console.log(error.response.data);
      dispatch({
        type: "LOGIN_USER_ERROR",
        payload: { msg: error.response.data.msg },
      });
    }
    setTimeout(() => {
      dispatch({
        type: "CLEAR_ALERT",
      });
    }, 1000);
  };
};

export const logoutUser = () => {
  return {
    type: "LOGOUT_USER",
  };
};

export const tempUser = (username) => {
  localStorage.setItem("user", JSON.stringify({ username }));
  return {
    type: "TEMP_USER",
    payload: username,
  };
};

export const loadTrivia = (data) => {
  return {
    type: "LOAD_TRIVIA",
    payload: data,
  };
};

export const unloadTrivia = () => {
  return {
    type: "UNLOAD_TRIVIA",
  };
};

export const nextPlayer = (player) => {
  return {
    type: "NEXT_PLAYER",
    payload: player,
  };
};

export const nextTurn = (turn) => {
  return {
    type: "NEXT_TURN",
    payload: turn,
  };
};

export const incrementScore = (updatedTriviaArray) => {
  return {
    type: "INCREMENT_SCORE",
    payload: updatedTriviaArray,
  };
};
